<template>
  <el-container class="indexbox">
    <div class="header-top">
      <div class="containerdiv">
        <div class="logo">
          <img src="../assets/iProX_logo.png" alt="">
        </div>
        <div class="top-menu">
          <div v-show="!islogin">
            <img src="https://test1.iprox.org.cn/assets/global/img/flags/us.png" alt="">
            <span style="padding-left: 5px;">English</span>
            <el-divider direction="vertical"></el-divider>
            <a href="https://test1.iprox.org.cn/cas/login?service=https://test1.iprox.org.cn/login%2Fcas&locale=en" style="padding-left: 15px;padding-right: 15px;">
              <span>Sign In</span>
            </a>
            <el-divider direction="vertical"></el-divider>
            <a href="https://test1.iprox.org.cn/page/URV001.html" style="padding-left: 15px;">
              <span>Register</span>
            </a>
          </div>
          <div v-show="islogin">
            <img src="https://test1.iprox.org.cn/assets/global/img/flags/us.png" alt="">
            <span style="padding-left: 5px;">English</span>
            <el-divider direction="vertical"></el-divider>
            <el-dropdown class="pointer mr10">
              <span class="el-dropdown-link">
                {{username}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <a href="https://test1.iprox.org.cn/page/UPV003.html" target="_blank">
                    <i class="el-icon-user-solid" />My Profile
                  </a>
                </el-dropdown-item>
                <el-dropdown-item><i class="fa fa-edit" />Change Password</el-dropdown-item>
                <el-dropdown-item><i class="fa fa-sign-out" />Log Out</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <i class="fa fa-sign-out" /> -->
          </div>
        </div>
      </div>
    </div>
    <el-header v-if="headerfixed"></el-header>
    <el-header id="boxFixed" :class="{headerfixed : headerfixed}">
      <div class="containerdiv">
        <el-row>
          <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
            <div class="header-menu">
              <!-- <div class="containerdiv"> -->
                <!-- <el-menu
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                  background-color="#444d58"
                  text-color="#4db3a4"
                  active-text-color="#ffd04b">
                  <el-menu-item index="1" v-for="(item,index) of menus" :key="'menus' + index" :index="item.path" v-if="item.isShow">
                    <router-link :to="item.path">{{item.meta.title}}</router-link>
                  </el-menu-item>
                </el-menu> -->
                <el-menu
                  :default-active="$route.path"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                  background-color="#444d58"
                  text-color="#4db3a4"
                  active-text-color="#4db3a4">
                  <el-menu-item v-for="(item,index) of menus" :key="'menus' + index" v-if="item.isShow && !item.isChildren"  :index="item.path">
                    <!--<router-link :to="item.path">{{item.meta.title}}</router-link>-->
                    <span>{{item.meta.title}}</span>
                    <!-- <a :href="item.path" :target="item.isBlank? '_blank': ''">{{item.meta.title}}</a> -->
                  </el-menu-item>
                  <el-submenu :index="index" v-for="(item,index) of menus" :key="'menus' + index" v-if="item.isShow && item.isChildren" >
                    <template slot="title">{{item.meta.title}}</template>
                    <el-menu-item v-for="(item2,index2) of item.children" :key="'menus' + index2"  :index="item2.path">
                      <span>{{item2.meta.title}}</span>
                    </el-menu-item>
                  </el-submenu>
                </el-menu>
              <!-- </div> -->
            </div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <el-input placeholder="Search" v-model="searchkey" style="margin-top: 10px;">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <!--<el-header class="headerfixed" v-if="!!headerfixed">-->
      <!--<div class="containerdiv">-->
        <!--<el-row>-->
          <!--<el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">-->
            <!--<div class="header-menu">-->
              <!--&lt;!&ndash; <div class="containerdiv"> &ndash;&gt;-->
                <!--&lt;!&ndash; <el-menu-->
                  <!--:default-active="activeIndex"-->
                  <!--class="el-menu-demo"-->
                  <!--mode="horizontal"-->
                  <!--@select="handleSelect"-->
                  <!--background-color="#444d58"-->
                  <!--text-color="#4db3a4"-->
                  <!--active-text-color="#ffd04b">-->
                  <!--<el-menu-item index="1" v-for="(item,index) of menus" :key="'menus' + index" :index="item.path" v-if="item.isShow">-->
                    <!--<router-link :to="item.path">{{item.meta.title}}</router-link>-->
                  <!--</el-menu-item>-->
                <!--</el-menu> &ndash;&gt;-->
                <!--<el-menu-->
                  <!--:default-active="activeIndex"-->
                  <!--class="el-menu-demo"-->
                  <!--mode="horizontal"-->
                  <!--@select="handleSelect"-->
                  <!--background-color="#444d58"-->
                  <!--text-color="#4db3a4"-->
                  <!--active-text-color="#ffd04b">-->
                  <!--<el-menu-item v-for="(item,index) of menus" :key="'menus' + index" v-if="item.isShow && !item.isChildren" @click="toPage(item.path)":index="index">-->
                    <!--&lt;!&ndash;<router-link :to="item.path">{{item.meta.title}}</router-link>&ndash;&gt;-->
                    <!--<span>{{item.meta.title}}</span>-->
                    <!--&lt;!&ndash; <a :href="item.path" :target="item.isBlank? '_blank': ''">{{item.meta.title}}</a> &ndash;&gt;-->
                  <!--</el-menu-item>-->
                  <!--<el-submenu :index="item.indexval" v-for="(item,index) of menus" :key="'menus' + index" v-if="item.isShow && item.isChildren">-->
                    <!--<template slot="title">{{item.meta.title}}</template>-->
                    <!--<el-menu-item v-for="(item2,index2) of item.children" :key="'menus' + index2" @click="toPage(item2.path)">-->
                      <!--<span>{{item2.meta.title}}</span>-->
                    <!--</el-menu-item>-->
                  <!--</el-submenu>-->
                <!--</el-menu>-->
              <!--&lt;!&ndash; </div> &ndash;&gt;-->
            <!--</div>-->
          <!--</el-col>-->
          <!--<el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">-->
            <!--<el-input placeholder="Search" v-model="searchkey" style="margin-top: 10px;">-->
              <!--<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>-->
            <!--</el-input>-->
          <!--</el-col>-->
        <!--</el-row>-->
      <!--</div>-->
    <!--</el-header>-->
    <el-main>
      <div class="containerdiv">
        <router-view/>
      </div>
    </el-main>
    <el-footer>
      <div class="containerdiv">
        Supported by National Center for Protein Sciences (Beijing)<br>
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备20012173号-1</a>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import { selectUserById } from '@/api';
import { menus } from '../router/menus';

export default {
  name: 'home',
  data() {
    return {
      menus,
      linkUrl: 'https://www.iprox.cn/',
      loading: false,
      activeIndex: 0,
      isOverflow: true,
      headerfixed: false,
      searchkey: '',
      islogin: false,
      username: '',
      authority: 0,
      newMenus: [],
    };
  },
  computed: {},
  mounted() {
    window.addEventListener('scroll', this.handleWheel);
  },
  created() {
    // console.error(this.$route.query,'this.$route.query++++++++++++++++++++++')
    // if(this.$route.query.aid == undefined) {
    //   this.islogin = false
    //   this.$store.commit('setLoginLevel',0)
    //   this.getMenuInfo()
    // } else {
    //   selectUserById({
    //     search: {
    //       user_id: this.$route.query.aid
    //     }
    //   }).then((res) => {
    //     this.$store.commit('setUserInfo',res.result[0])
    //     if(res.result[0].user_name != '' && res.result[0].authority != '') {
    //       this.islogin = true
    //       this.username = res.result[0].user_name
    //       this.authority = res.result[0].authority
    //       if(res.result[0].authority == '1' || res.result[0].authority == '8') {
    //         this.$store.commit('setLoginLevel', 1)
    //       } else {
    //         this.$store.commit('setLoginLevel',2)
    //       }
    //     } else {
    //       this.islogin = false
    //       this.$store.commit('setLoginLevel',0)
    //     }
    //     // this.$store.commit('setLoginLevel',0)
    //     this.getMenuInfo()
    //   })
    // }

    // selectUserById({
    //   search: {
    //     user_id: this.$route.query.aid
    //   }
    // }).then((res) => {
    //   this.$store.commit('setUserInfo',res.result[0])
    //   if(res.result[0].user_name != '' && res.result[0].authority != '') {
    //     this.islogin = true
    //     this.username = res.result[0].user_name
    //     this.authority = res.result[0].authority
    //     if(res.result[0].authority == '1' || res.result[0].authority == '8') {
    //       this.$store.commit('setLoginLevel', 1)
    //     } else {
    //       this.$store.commit('setLoginLevel',2)
    //     }
    //   } else {
    //     this.islogin = false
    //     this.$store.commit('setLoginLevel',0)
    //   }
    //   // this.$store.commit('setLoginLevel',0)
    //   this.getMenuInfo()
    // })
    //      setTimeout(() => {
    //        this.$store.commit('setLoginLevel',1)
    //        this.getMenuInfo()
    //      },1000)
    //        this.$store.commit('setLoginLevel',0)
    // if(this.$store.state.userInfo.user_name != '' && this.$store.state.userInfo.authority != '') {
    //   this.islogin = true
    //   this.username = this.$store.state.userInfo.user_name
    //   this.authority = this.$store.state.userInfo.authority
    // } else {
    //   this.islogin = false
    // }
    // console.log(this.islogin)
  },
  watch: {

  },
  methods: {
    getMenuInfo() {
      this.menus.forEach((item) => {
        item.isShow = this.showMenueByLoginLevel(item);
      });
      //          if (this.$store.state.loginLevel  == 0) { // 未登录
      //            this.menus = menus.filter(item => {
      //              return !item.isLogin
      //            })
      //          } else if (this.$store.state.loginLevel  == 1) { // 已经登录且登录角色是普通用户
      //            this.menus = menus.filter(item => {
      //              return !item.isLogin || (item.isLogin && !item.isAdmin)
      //            })
      //          } else if (this.$store.state.loginLevel  == 2) { // 登录用户为管理员
      //            this.menus = menus.filter(item => {
      //              return !item.notNeedAdmin
      //            })
      //          }
    },
    handleWheel() {
      const scrollTop = window.pageYOffset
          || document.documentElement.scrollTop
          || document.body.scrollTop;
      if (scrollTop >= 88) {
        this.headerfixed = true;
      } else {
        this.headerfixed = false;
      }
    },
    handleLinkmenu(param) {
      window.open(param);
    },
    handleSelect(index, indexPath) {
      console.log(index, indexPath);
      const pathurl = index;
      //        if (indexPath.length == 1) {
      //          pathurl = this.menus[index].path
      //        } else {
      //          let indexSst = index.split('-')[0]
      //          let indexSst1 = index.split('-')[1]
      //          pathurl = this.menus[parseInt(indexSst)].children[parseInt(indexSst1)].path
      //        }
      this.toPage(pathurl);
      //        debugger
      //        this.$router.push({path: index})
    },
    toPage(pathurl) {
      if (pathurl && pathurl.indexOf('http') > -1) {
        window.open(pathurl, '_blank');
      } else {
        // this.$router.push(pathurl)
        this.$router.push({ path: pathurl });
      }
    },
    handleSearch() {
      const inputval = this.searchkey.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
      this.$router.push({ path: '/search', query: { sval: inputval } });
    },
    showMenueByLoginLevel(item) {
      let flag = false;
      if (this.$store.state.loginLevel == 0) { // 未登录
        if (!item.isLogin) {
          flag = true;
        }
      } else if (this.$store.state.loginLevel == 1) { // 已经登录且登录角色是普通用户
        if (!item.isLogin || (item.isLogin && !item.isAdmin)) {
          flag = true;
        }
      } else if (this.$store.state.loginLevel == 2) { // 登录用户为管理员
        if (!item.notNeedAdmin) {
          flag = true;
        }
      }
      return flag;
    },
  },
  fillters: {

  },
};
</script>
<style lang="scss" scoped>
  .header-top {
    line-height: 75px;
    .logo {
      float: left;
      display: block;
      width: 255px;
      height: 75px;
      img {
        width: 710px;
        height: 45px;
        margin: 29.5px 0 0 0;
      }
    }
    .top-menu {
      margin: 13px 0 0;
      padding: 0;
      float: right;
      font-size: 16px;
    }
  }
  .el-header {
    background: #444d58;
    width: 1370px;
    // font-weight: 700;
  }
  .el-footer {
    background: #3b434c;
    color: #a2abb7;
    font-size: 14px;
    font-weight: 300;
    padding: 17px 0;
  }
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .containerdiv {
    /*width: 1370px;*/
    // width: 90%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  a {
    text-shadow: none;
    color: #5b9bd1;
    text-decoration: none;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt15 {
    margin-top: 15px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  /deep/.el-collapse-item__header {
    font-size: 20px;
    padding-left: 10px;
    background-color: #26A69A;
    color: #fff;
    border-radius: 4px;
  }
  /deep/.el-collapse-item__content {
    padding-bottom: 0;
    font-size: 14px;
    color: #545758;
  }
  /deep/.el-collapse-item__wrap {
    background-color: #D9EDF7;
  }
  h4 {
    font-family: "Open Sans", sans-serif;
    font-weight: 300;
  }
  /deep/.el-card {
    border: 1px solid #30d0c1;
  }
  /deep/.el-card__header {
    padding: 10px 20px;
    color: #fff;
    background-color: #26a69a;
    font-size: 20px;
  }
  /deep/ .el-dropdown-menu__item, .el-menu-item {
    font-size: 18px;
  }
  .el-menu-item {
    font-size: 18px;
    padding: 0 20px;
    // font-size: 14px;
    // padding: 0 15px;
    // font-weight: 700;
  }
  /deep/ .el-submenu__title {
    font-size: 18px;
    padding: 0 20px;
    // padding: 0 15px;
    // font-size: 14px;
    // font-weight: 700;
  }
  .headerfixed {
    background: #444d58;
    height: 60px;
    position: fixed;
    z-index: 1000;
    width: 100%;
  }
  .el-main {
    width: 1370px;
    padding: 20px 0px;
  }
  @media screen and (min-width: 1370px) {
    .el-header {
      width: 100%;
    }
    .el-main {
      width: 100%;
    }
    .containerdiv {
      width: 1370px;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
  }
  // @media screen and (min-width: 1366px) {
  //   #boxFixed {
  //     .header-menu {
  //       width: 100%;
  //     }
  //     .containerdiv {
  //       width: 100%;
  //       display: flex;
  //       justify-content: space-between;
  //       align-items: center;
  //     }
  //     .header-search {
  //       width: 240px;
  //     }
  //   }
  // }
</style>
